import { COVER_PRESETS, resolvePreset } from '@/lib/ebookCovers';

interface Props {
  preset?: string | null;
  title: string;
}

export function EbookMiniCover({ preset, title }: Props) {
  const isUrl = !!preset && preset.startsWith('http');

  if (isUrl) {
    return (
      <img
        src={preset as string}
        alt={title}
        loading="lazy"
        className="shrink-0"
        style={{
          width: 48,
          height: 62,
          objectFit: 'cover',
          borderRadius: 4,
        }}
      />
    );
  }

  const p = COVER_PRESETS[resolvePreset(preset)];
  return (
    <div
      className="flex flex-col items-center justify-center shrink-0 px-1 text-center"
      style={{
        width: 48,
        height: 62,
        background: p.bg,
        border: `1px solid ${p.border}`,
        borderRadius: 4,
      }}
    >
      <div
        style={{
          fontSize: 7,
          lineHeight: 1.2,
          color: 'rgba(255,255,255,0.7)',
          fontWeight: 500,
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
        }}
      >
        {title}
      </div>
      <div style={{ fontSize: 6, color: 'rgba(255,255,255,0.35)', marginTop: 2 }}>Dr. Kim</div>
    </div>
  );
}
